import GetLoading from "../../share/getLoading";
// import {
//   Table,
//   Pagination,
//   Space,
//   Button,
//   Modal,
//   Input,
//   DatePicker,
//   TreeSelect,
//   Checkbox,
//   Tag,
// } from "antd";

// import { useState, useEffect, useMemo } from "react";
// import { request } from "../../share/request";
// import "../../styles/Home-module.css";
// import { BsDownload } from "react-icons/bs";
// import style from "../../styles/style.module.css";

// import { MdOutlineEdit, MdOutlineDelete } from "react-icons/md";
// import { formateDateClient, formateDateSystem } from "../../share/helper";
// import { getJobStatus } from "../../share/getStatusContent";
// //  for export data to excel
// import ExcelJS from "exceljs";
// import * as FileSaver from "file-saver";
// import moment from "moment";
// import { openNotification } from "../../share/message";
// import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
// import { getCurrentUser } from "../../share/getProfile";
// import "./Model-Setting-Grid.css";

// // -----------------  end import --------------------

// const EmployeePage = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageNumber, setPageNumber] = useState(1);
//   const getProfile = getCurrentUser();
//   const [ListExcelData, setListExcelData] = useState([]);
//   const [loadingSpin, setLoadingSpin] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [DownloadReport, setDownloadReport] = useState(false);
//   const [dataSours, setDataSoure] = useState([]);
//   const [totalpage, setTotalPage] = useState(1);
//   const [selectOrgCodeSave, setSelectOrgCodeSave] = useState(
//     getProfile.org_code
//   );

//   const [size, setSize] = useState(1);
//   const [pagesize, setPageSize] = useState(10);
//   const [objFilter, setObjFilter] = useState({
//     page: 1,
//     org_code: getProfile.org_code,
//   });
//   useEffect(() => {
//     getMasterGroups();
//     // block form load
//     getList(objFilter);
//   }, []);

//   const getList = async (objFilter) => {
//     const param = new URLSearchParams({
//       page: objFilter.page,
//       org_code: getProfile.org_code,
//     });

//     // create function success

//     try {
//       const res = await request(
//         "employeereport?" + param.toString(),
//         "get",
//         {}
//       );
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       if (res) {
//         setDataSoure(res.ListEmployeeData[0]);
//         setTotalPage(res.totalRecord);
//       }
//     } catch (error) {
//     } finally {
//       setLoading(false);
//     }
//   };

//   const columns = [
//     {
//       title: "ID",
//       dataIndex: "id",
//       render: (text, record, index) => {
//         // Assuming `page` and `pageSize` are available in your component scope
//         return <div>{(pageNumber - 1) * pagesize + index + 1}</div>; // Proper formula for page-based indexing
//       },
//     },

 
// {
//   title: "ឈ្មោះមន្ត្រីរាជការ",
//   dataIndex: "fullname",
//   render: (text, record) => {
//     const getRandomColor = () => {
//       const colors = [
//         "#FF5733", "#33B5E5", "#AA66CC", "#99CC00",
//         "#FFBB33", "#FF4444", "#0099CC", "#9933CC"
//       ];
//       return colors[Math.floor(Math.random() * colors.length)];
//     };

//     const avatarColor = getRandomColor();

//     return (
//       <div style={{ display: "flex", alignItems: "center" }}>
//         {/* Avatar */}
//         <div
//           style={{
//             backgroundColor: avatarColor,
//             color: "white",
//             width:40,
//             height: 40,
//             borderRadius: "50%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontWeight: "bold",
//             fontSize: 14,
//             marginRight: 8,
//           }}
//         >
//           {record.fullname?.charAt(0).toUpperCase()}
//         </div>

//         {/* Text info */}
//         <div>
//           <div style={{ fontSize: "14px" }}>{record.fullname} |  {record.staffname_eng}</div>
//           <div style={{ fontSize: "12px", marginTop: 0, color: "#BFBFBF" }}>
//           {record.idnumber} 
//           </div>
//         </div>
//       </div>
//     );
//   },
// }
// ,

//     {
//       title: "ភេទ",
//       dataIndex: "gender",
//     },

//     {
//       title: "ផ្នែក និងតួរនាទី",
//       dataIndex: "department",
//       render: (text, record) => (
//         <div>
//           <div style={{ fontSize: "14px" }}>{record.department}</div>
//           <div style={{ fontSize: "12px", marginTop: 0, color: "#BFBFBF" }}>
//             {record.position}
//           </div>
//         </div>
//       ),
//     },
//     {
//       title: "ជំនាញ",
//       dataIndex: "skill",
//     },
//     {
//       title: "ថ្ងៃចូលបម្រើការងារ",
//       dataIndex: "joinwork",
//       render: (text, record) => <div>{formateDateSystem(record.joinwork)}</div>,
//     },
//     {
//       title: "កាំប្រាក់",
//       dataIndex: "level",
//     },
//     {
//       title: "ថ្ងៃឡើងកាំប្រាក់",
//       dataIndex: "date_last_upgrad",
//       render: (text, record) => (
//         <div>{formateDateSystem(record.date_last_upgrad)}</div>
//       ),
//     },
//     {
//       title: "ប្រភេទបុគ្គលិក",
//       dataIndex: "stafftype",
//       render: (text, record) => <div>{getJobStatus(record.stafftype)}</div>,
//     },
//     {
//       title: "ស្ថានភាព",
//       dataIndex: "jobstatus",
//       render: (text, record) => <div>{getJobStatus(record.jobstatus)}</div>,
//     },

//     {
//       title: "សកម្មភាព",
//       render: (_, record, index) => (
//         <Space>
//           <Button type="primary" icon={<MdOutlineEdit />} />
//           <Button type="primary" icon={<MdOutlineDelete />} danger />
//         </Space>
//       ),
//     },
//   ];
//   // // for one file excel download
//   // const onExporttoExcel = async () => {
//   //   const idorg = getProfile.org_code;
//   //   console.log("ID org : ", idorg);
//   //   const param = new URLSearchParams({
//   //     idorg: idorg,
//   //   });
//   //   const res = await request("employeeexcel?" + param.toString(), "get", {});
//   //   if (res) {
//   //     // Ensure res.dataRequestLeave is an array
//   //     const dataArray = Array.isArray(res.ListEmployeeDownloadExcell_gov[0])
//   //       ? res.ListEmployeeDownloadExcell_gov[0]
//   //       : [];
//   //     setListExcelData(dataArray);
//   //     console.log("res", dataArray);

//   //     // Return the array for further use if needed
//   //     return dataArray;
//   //   }

//   //   // Return an empty array or handle the case when 'res' is falsy
//   //   return [];
//   // };
//   const onExporttoExcel = async () => {
//     const orgCodes = param_org;
//     // Ensure orgCodes is a comma-separated string, even for a single org
//     const idorg = Array.isArray(orgCodes) ? orgCodes.join(",") : orgCodes;

//     console.log("ID org : ", idorg);

//     // Prepare URL parameters
//     const param = new URLSearchParams({
//       idorg: idorg, // Pass single or multiple IDs
//     });

//     try {
//       // Make the GET request to the API endpoint
//       const res = await request(`employeeexcel?${param.toString()}`, "get", {});
//       if (res) {
//         // Extract the correct data array
//         const dataArray = Array.isArray(res.ListEmployeeDownloadExcell_gov)
//           ? res.ListEmployeeDownloadExcell_gov[0] || []
//           : [];

//         // Update the state
//         setListExcelData(dataArray);
//         console.log("res", dataArray);

//         // Return the array for further use
//         return dataArray;
//       }
//     } catch (error) {
//       console.error("Error fetching Excel data:", error);
//     }

//     // Return an empty array if something goes wrong
//     return [];
//   };

//   const onExporttoExcel_other = async () => {
//     const orgCodes = param_org;
//     // Ensure orgCodes is a comma-separated string, even for a single org
//     const idorg = Array.isArray(orgCodes) ? orgCodes.join(",") : orgCodes;

//     console.log("ID org : ", idorg);

//     // Prepare URL parameters
//     const param = new URLSearchParams({
//       idorg: idorg, // Pass single or multiple IDs
//     });
//     const res = await request(`employeeexcel?${param.toString()}`, "get", {});
//     if (res) {
//       // Ensure res.dataRequestLeave is an array
//       const dataArray = Array.isArray(res.ListEmployeeDownloadExcell_other[0])
//         ? res.ListEmployeeDownloadExcell_other[0]
//         : [];
//       setListExcelData(dataArray);
//       console.log("res", dataArray);

//       // Return the array for further use if needed
//       return dataArray;
//     }

//     // Return an empty array or handle the case when 'res' is falsy
//     return [];
//   };
//   const onExporttoExcel_TotalAll = async () => {
//     const orgCodes = param_org;
//     // Ensure orgCodes is a comma-separated string, even for a single org
//     const idorg = Array.isArray(orgCodes) ? orgCodes.join(",") : orgCodes;

//     console.log("ID org : ", idorg);

//     // Prepare URL parameters
//     const param = new URLSearchParams({
//       idorg: idorg, // Pass single or multiple IDs
//     });
//     const res = await request(`employeeexcel?${param.toString()}`, "get", {});
//     if (res) {
//       // Ensure res.dataRequestLeave is an array
//       const dataArray = Array.isArray(
//         res.ListEmployeeDownloadExcell_TotalAll[0]
//       )
//         ? res.ListEmployeeDownloadExcell_TotalAll[0]
//         : [];
//       setListExcelData(dataArray);
//       console.log("res", dataArray);

//       // Return the array for further use if needed
//       return dataArray;
//     }

//     // Return an empty array or handle the case when 'res' is falsy
//     return [];
//   };

//   const downloadExcel = async () => {
//     const OrgName = getProfile.org_name_kh;

//     try {
//       setLoadingSpin(true);
//       setDownloadReport(false);

//       // Fetch data and ensure it's an array
//       const data = (await onExporttoExcel()) || [];
//       const data_other = (await onExporttoExcel_other()) || [];
//       const data_TotalAll = (await onExporttoExcel_TotalAll()) || [];

//       // Load the template Excel file from the public folder
//       const templatePath =
//         process.env.PUBLIC_URL + "/template/templatestaff.xlsx";
//       const response = await fetch(templatePath);
//       const templateArrayBuffer = await response.arrayBuffer();

//       // Create a workbook from the template file
//       const workbook = new ExcelJS.Workbook();
//       await workbook.xlsx.load(templateArrayBuffer);

//       // Get the sheets from the workbook
//       const dataSheet = workbook.getWorksheet("staffgov");
//       const otherSheet = workbook.getWorksheet("staffothers");
//       const TotalAllSheet = workbook.getWorksheet("total-all");

//       if (!dataSheet || !otherSheet || !TotalAllSheet) {
//         console.error("One or more sheets not found in the template.");
//         return;
//       }

//       dataSheet.getCell("A2").value = OrgName;

//       // Convert the new data to worksheet format
//       const newData = data.map((item) => Object.values(item));
//       const newData_other = data_other.map((item) => Object.values(item));
//       const newData_TotalAll = data_TotalAll.map((item) => Object.values(item));

//       // Check if the data arrays are valid
//       if (newData.length === 0) {
//         console.warn("No data available for the main data sheet.");
//       }
//       if (newData_other.length === 0) {
//         console.warn("No data available for the other data sheet.");
//       }
//       if (newData_TotalAll.length === 0) {
//         console.warn("No data available for the total all data sheet.");
//       }

//       // Append the new data to the existing sheets
//       if (newData.length > 0) {
//         dataSheet.addTable({
//           name: "dataTable",
//           ref: "B6",
//           headerRow: true,
//           columns: Object.keys(data[0]).map((key) => ({ name: key })),
//           rows: newData,
//         });
//       }

//       if (newData_other.length > 0) {
//         otherSheet.addTable({
//           name: "dataTable1",
//           ref: "B6",
//           headerRow: true,
//           columns: Object.keys(data_other[0]).map((key) => ({ name: key })),
//           rows: newData_other,
//         });
//       }

//       if (newData_TotalAll.length > 0) {
//         TotalAllSheet.addTable({
//           name: "dataTable2",
//           ref: "A6",
//           headerRow: true,
//           columns: Object.keys(data_TotalAll[0]).map((key) => ({ name: key })),
//           rows: newData_TotalAll,
//         });
//       }

//       // Hide unnecessary rows in each sheet
//       const hideRows = (sheet, length) => {
//         const startRowToDelete = length + 7;
//         const endRowToHide = 1000;

//         for (let row = startRowToDelete; row <= endRowToHide; row++) {
//           sheet.getRow(row).height = 0.1; // Hide the row
//         }
//       };

//       hideRows(dataSheet, newData.length);
//       hideRows(otherSheet, newData_other.length);
//       hideRows(TotalAllSheet, newData_TotalAll.length);

//       // Apply Background Color Logic

//       const applyBackgroundColor = (sheet, data) => {
//         for (let row = 7; row <= data.length + 6; row++) {
//           const colAValue = sheet.getCell(row, 1).value; // Column A
//           const colBValue = sheet.getCell(row, 2).value; // Column B
//           const colCValue = sheet.getCell(row, 3).value; // Column C
//           const colDValue = sheet.getCell(row, 4).value; // Column D
//           // Ensure Column B is empty (null or empty string after trimming) and Column C is not null
//           if (
//             colAValue == null &&
//             colBValue == null &&
//             colCValue != null &&
//             colDValue == null
//           ) {
//             for (let col = 1; col <= 19; col++) {
//               // Loop through all columns in the row
//               sheet.getCell(row, col).fill = {
//                 type: "pattern",
//                 pattern: "solid",
//                 fgColor: { argb: "AED6F1" }, // Light blue background
//               };
//             }
//           }
//         }
//       };

//       applyBackgroundColor(dataSheet, newData);
//       applyBackgroundColor(otherSheet, newData_other);

//       // Handle subtotal formulas
//       const applySubtotal = (sheet, data) => {
//         for (let row = 7; row <= data.length + 6; row++) {
//           const cellValue = sheet.getCell(row, 2).value;
//           if (cellValue === 1) {
//             const subtotalFormula = {
//               formula: `SUBTOTAL(109, B$7:B${row})`,
//             };
//             sheet.getCell(row, 1).value = subtotalFormula;
//           }
//         }
//       };

//       applySubtotal(dataSheet, newData);
//       applySubtotal(otherSheet, newData_other);

//       // Background color for TotalAll sheet
//       for (let row = 7; row <= newData_TotalAll.length + 6; row++) {
//         const cellValue = TotalAllSheet.getCell(row, 2).value;
//         if (cellValue != null) {
//           for (let col = 1; col <= 5; col++) {
//             const cell = TotalAllSheet.getCell(row, col);
//             cell.fill = {
//               type: "pattern",
//               pattern: "solid",
//               fgColor: { argb: "FFCCCC" },
//             };
//             cell.font = {
//               bold: true,
//               name: "Content",
//             };
//           }
//         }
//       }

//       // Save the modified workbook as a Blob with XLSX format
//       const blob = await workbook.xlsx.writeBuffer();
//       const name_report = `StaffSummaryReport-${moment().format(
//         "MM-DD-YYYY-HH:mm:ss"
//       )}`;
//       FileSaver.saveAs(new Blob([blob]), `${name_report}.xlsx`);
//     } catch (error) {
//       console.error("An error occurred while generating the report:", error); // Log detailed error
//       openNotification("error", "Error", "Error while downloading report");
//     } finally {
//       setLoadingSpin(false);
//     }
//   };

//   const onCancelDownload = () => {
//     setDownloadReport(false);
//   };
//   const opOpenModelDownloadReport = () => {
//     setDownloadReport(true);
//   };

//   const onShowSizeChange = async (current) => {
//     console.log(current);
//     setPageNumber(current);
//     setCurrentPage(current);
//     try {
//       setLoadingSpin(false);
//       var objTmp = {
//         ...objFilter,
//         page: current,
//       };
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       setObjFilter(objTmp);
//       getList(objTmp);
//     } catch (error) {
//     } finally {
//       setLoadingSpin(false);
//     }
//   };

//   const [ListMasterGroup, setListMasterGroup] = useState([]);
//   const getMasterGroups = async () => {
//     const param = new URLSearchParams({ org_code: getProfile.org_code });

//     const res = await request("usermastergroup?" + param.toString(), "get", {});
//     if (res) {
//       setListMasterGroup(res.list_api_master_group[0]);
//     }
//   };
//   const [selectedIndex, setSelectedIndex] = useState(null); // Store the selected index
//   const [param_org, setParamOrg] = useState(getProfile.org_code);
//   // const treeData = ListMasterGroup.reduce((acc, item) => {
//   //   const groupId = item.group_id || "Unknown"; // Use "Unknown" as a fallback
//   //   const nameUnknow = item.org_name_kh;
//   //   const groupName = item.group_name || nameUnknow; // Use "Unknown" as a fallback
//   //   const group = acc.find((g) => g.value === groupId);
//   //   if (group) {
//   //     group.children.push({
//   //       title: item.org_name_kh,
//   //       value: item.org_code,
//   //       key: item.organization_id,
//   //     });
//   //   } else {
//   //     acc.push({
//   //       title: `${groupName}`, // Use fallback or default group name
//   //       value: groupId,
//   //       key: `${groupId}`,
//   //       children: [
//   //         {
//   //           title: item.org_name_kh,
//   //           value: item.org_code,
//   //           key: item.organization_id,
//   //         },
//   //       ],
//   //     });
//   //   }
//   //   return acc;
//   // }, []);
//   // const [selectedIndex, setSelectedIndex] = useState(null); // Store the selected index
//   // const findOrgByValue = (value, data) => {
//   //   let foundOrg = null;
//   //   data.some((node) => {
//   //     if (node.value === value) {
//   //       foundOrg = node;
//   //       return true;
//   //     }
//   //     // Recursively search in the children
//   //     if (node.children && node.children.length > 0) {
//   //       foundOrg = findOrgByValue(value, node.children);
//   //       return foundOrg ? true : false;
//   //     }
//   //     return false;
//   //   });
//   //   return foundOrg;
//   // };
//   // const findOrgIndex = (value, data, parentIndex = null) => {
//   //   let index = -1;
//   //   data.some((node, idx) => {
//   //     // Check if the current node matches the selected value
//   //     if (node.value === value) {
//   //       index = parentIndex !== null ? `${parentIndex}-${idx}` : idx;
//   //       return true;
//   //     }

//   //     // If there are children, recursively search in the children
//   //     if (node.children && node.children.length > 0) {
//   //       index = findOrgIndex(value, node.children, idx); // Pass current index as parentIndex
//   //       return index !== -1;
//   //     }
//   //     return false;
//   //   });
//   //   return index;
//   // };
//   // const onChangeOrganization_Multiple = async (value) => {
//   //   const selectedOrg = findOrgByValue(value, treeData);
//   //   const orgIndex = findOrgIndex(value, treeData);
//   //   if (selectedOrg) {
//   //     const groupId = selectedOrg.groupId; // Get the groupId (parent)
//   //     const orgCode = selectedOrg.value; // The orgCode of the selected organization

//   //     setSelectOrgCodeSave(orgCode);

//   //     setSelectedIndex(orgIndex); // Store the index of the selected org

//   //     // Log the selected values
//   //     console.table({ groupId, orgCode, index: orgIndex });
//   //     console.log("this is index number: ", selectedIndex);
//   //     console.log(" selected type : ", selectedOrg);
//   //     const newfilter = {
//   //       ...objFilter,
//   //       org_code: orgCode,
//   //     };
//   //     console.table("new fileter : ", newfilter);
//   //   }
//   // };
//   const treeData = useMemo(() => {
//     return ListMasterGroup.reduce((acc, item) => {
//       const groupId = item.group_id || "Unknown";
//       const groupName = item.group_name || item.org_name_kh || "Unknown";
//       const group = acc.find((g) => g.value === groupId);
//       if (group) {
//         group.children.push({
//           title: item.org_name_kh,
//           value: item.org_code,
//           key: item.organization_id,
//         });
//       } else {
//         acc.push({
//           title: groupName,
//           value: groupId,
//           key: `${groupId}`,
//           children: [
//             {
//               title: item.org_name_kh,
//               value: item.org_code,
//               key: item.organization_id,
//             },
//           ],
//         });
//       }
//       return acc;
//     }, []);
//   }, [ListMasterGroup]);
//   const findOrg = (value, data, parentIndex = null) => {
//     for (let idx = 0; idx < data.length; idx++) {
//       const node = data[idx];

//       if (node.value === value) {
//         return {
//           org: node,
//           index: parentIndex !== null ? `${parentIndex}-${idx}` : idx,
//         };
//       }

//       if (node.children && node.children.length > 0) {
//         const result = findOrg(value, node.children, idx);
//         if (result) return result;
//       }
//     }
//     return null;
//   };
//   const handleTreeSelectChange = (value) => {
//     if (!value || value.length === 0) {
//       // Clear selection
//       setSelectOrgCodeSave([]);
//     } else {
//       // Update selected values
//       setSelectOrgCodeSave(value);
//     }

//     console.log("Updated Selected Values: ", value);
//     setParamOrg(value);
//   };

//   return (
//     <div>
//       <div>
//         <div className="sprinSave-container">
//           {/* Your other components */}
//           {loadingSpin && (
//             <div className="sprinSave">
//               <GetLoading />
//             </div>
//           )}
//         </div>

//         {/* <div className={style.sarchPenel} style={boxHeader}>
//           <div className={style.sarchPenel}>
//             <Space>
//               {boxHeaderTagText("មន្រ្តីរាជការ បុគ្គលិកជួល...")}

//               <div style={{ display: "flex" }}>
//                 <Space>
//                   <Input placeholder="Search..." allowClear />
//                 </Space>
//               </div>
//             </Space>
//           </div>
//           <div>
//             <Space>
//               <Button
//                 className="buttonstylekhmer"
//                 onClick={opOpenModelDownloadReport}
//                 type="primary"
//                 icon={<BsDownload />}
//               >
//                 ទាយយករបាយការណ៍
//               </Button>
//             </Space>
//           </div>
//         </div> */}

//         <div style={boxHeader}>
//           <div className="Header-Setting-Grid">
//             <div className="Header-Setting-Grid-R">
//               {boxHeaderTagText("មន្រ្តីរាជការ បុគ្គលិកជួល...")}

//               <Space>
//                 <Input
//                   className="styleTageStatusForm"
//                   placeholder="Search..."
//                   allowClear
//                 />
//               </Space>
//             </div>

//             <div>
//               <Space>
//                 <Button
//                   className="buttonstylekhmer"
//                   onClick={opOpenModelDownloadReport}
//                   type="primary"
//                   icon={<BsDownload />}
//                 >
//                   ទាយយករបាយការណ៍
//                 </Button>
//               </Space>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className="sprinCustome">
//             <GetLoading />
//           </div>
//         ) : (
//           <Table
//             size="small"
//             tableLayout="auto"
//             columns={columns}
//             dataSource={dataSours}
//             pagination={false}
//           />
//         )}
//         <div style={{ marginTop: 10 }}>
//           <Pagination
//             showSizeChanger
//             onChange={onShowSizeChange}
//             defaultCurrent={currentPage}
//             total={totalpage}
//           />
//         </div>
//       </div>
//       <Modal
//         title="ទាញរបាយការណ៍"
//         className="custom-modal" // Use the custom-modal class for responsive styles
//         open={DownloadReport}
//         footer={[
//           <div>
//             <Space>
//               {" "}
//               <Button onClick={onCancelDownload}>Cancel</Button>
//               <Button
//                 className="custom-form-item"
//                 type="primary"
//                 onClick={downloadExcel}
//               >
//                 ទាញយកសង្ខេបរបាយការណ៍បុគ្គលិក (Excel)
//               </Button>
//             </Space>
//           </div>,
//         ]}
//       >
//         <div style={{ width: "520px" }}>
//           <Space>
//             {/* <Tag style={{ padding: 7 }}>
//               <Checkbox>អង្គភាពទាំងអស់</Checkbox>
//             </Tag> */}
//             <TreeSelect
//               allowClear
//               showSearch
//               treeCheckable={true} // Enables checkboxes for multiple selection
//               multiple={true} // Enables multiple selection
//               style={{ width: "500px" }}
//               value={selectOrgCodeSave} // Controlled value
//               dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
//               treeData={treeData} // Dynamic treeData
//               placeholder="Select Organization(s)"
//               treeDefaultExpandAll
//               filterTreeNode={(input, treeNode) =>
//                 treeNode.title.toLowerCase().includes(input.toLowerCase())
//               }
//               onChange={(value) => handleTreeSelectChange(value)} // Change handler
//             />
//           </Space>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default EmployeePage;


import {
  Table,
  Pagination,
  Space,
  Button,
  Modal,
  Input,
  DatePicker,
  TreeSelect,
  Checkbox,
  Tag,
  Tooltip,
} from "antd";

import { useState, useEffect, useMemo } from "react";
import { request } from "../../share/request";
import "../../styles/Home-module.css";
import { BsDownload } from "react-icons/bs";
import style from "../../styles/style.module.css";
import { MdOutlineEdit, MdOutlineDelete } from "react-icons/md";
import { formateDateClient, formateDateSystem, linkPath } from "../../share/helper";
import { getJobStatus } from "../../share/getStatusContent";
// for export data to excel
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import moment from "moment";
import { openNotification } from "../../share/message";
import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
import { getCurrentUser } from "../../share/getProfile";
import "./Model-Setting-Grid.css";

// ----------------- end import --------------------

const EmployeePage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const getProfile = getCurrentUser();
  const [ListExcelData, setListExcelData] = useState([]);
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [DownloadReport, setDownloadReport] = useState(false);
  const [dataSours, setDataSoure] = useState([]);
  const [totalpage, setTotalPage] = useState(1);
  const [selectOrgCodeSave, setSelectOrgCodeSave] = useState(
    getProfile.org_code
  );

  const [size, setSize] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [txtSearch, setTxtSearch] = useState("");
  const [objFilter, setObjFilter] = useState({
    page: 1,
    org_code: getProfile.org_code,
    txtSearch: "",
  });

  useEffect(() => {
    getMasterGroups();
    getList(objFilter);
  }, []);

  // Helper function to get image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    return linkPath + (imagePath.startsWith('/') ? imagePath : '/' + imagePath);
  };

  const getList = async (filterParams) => {
    const param = new URLSearchParams({
      page: filterParams.page,
      org_code: getProfile.org_code,
      txtSearch: filterParams.txtSearch || "",
    });

    try {
      const res = await request(
        "employeereport?" + param.toString(),
        "get",
        {}
      );
      await new Promise((resolve) => setTimeout(resolve, 400));
      if (res) {
        setDataSoure(res.ListEmployeeData[0] || []);
        setTotalPage(res.totalRecord);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle search
  const handleSearch = (value) => {
    setTxtSearch(value);
    const newFilter = {
      ...objFilter,
      txtSearch: value,
      page: 1,
    };
    setObjFilter(newFilter);
    setCurrentPage(1);
    setPageNumber(1);
    getList(newFilter);
  };

  const columns = [
    {
      title: "ល.រ",
      dataIndex: "id",
      width: 60,
      align: "center",
      render: (text, record, index) => {
        return <div>{(pageNumber - 1) * pagesize + index + 1}</div>;
      },
    },
    {
      title: "ឈ្មោះមន្ត្រីរាជការ",
      dataIndex: "fullname",
      width: 280,
      render: (text, record) => {
        // Get image URL
        const imageUrl = getImageUrl(record.image);
        
        // Fallback colors if no image
        const getAvatarColor = (name) => {
          const colors = [
            "#FF5733", "#33B5E5", "#AA66CC", "#99CC00",
            "#FFBB33", "#FF4444", "#0099CC", "#9933CC",
            "#2ECC71", "#E74C3C", "#3498DB", "#F39C12"
          ];
          const charCode = name?.charCodeAt(0) || 0;
          return colors[charCode % colors.length];
        };

        const avatarColor = getAvatarColor(record.fullname);
        
        // Determine status dot color
        const isActive = record.lock_user === 1;
        const dotColor = isActive ? "#52c41a" : "#ff4d4f";
        const statusTooltip = isActive ? "សកម្ម" : "អសកម្ម";

        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Avatar with status dot */}
            <div style={{ position: "relative", marginRight: 10, flexShrink: 0 }}>
              {/* Main Avatar */}
              <div
                style={{
                  backgroundColor: !imageUrl ? avatarColor : "transparent",
                  color: "white",
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: 16,
                  overflow: "hidden",
                  border: `2px solid ${!imageUrl ? avatarColor : '#e8e8e8'}`,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
                title={`${record.fullname} - ${statusTooltip}`}
              >
                {imageUrl ? (
                  <img 
                    src={imageUrl} 
                    alt={record.fullname}
                    style={{ 
                      width: "100%", 
                      height: "100%", 
                      objectFit: "cover",
                      borderRadius: "50%"
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const parent = e.target.parentNode;
                      parent.style.backgroundColor = avatarColor;
                      parent.style.color = "white";
                      parent.style.border = `2px solid ${avatarColor}`;
                      const fallback = document.createElement('span');
                      fallback.style.cssText = 'font-size:18px;font-weight:bold;';
                      fallback.textContent = record.fullname?.charAt(0).toUpperCase() || '?';
                      parent.appendChild(fallback);
                    }}
                  />
                ) : (
                  record.fullname?.charAt(0).toUpperCase() || '?'
                )}
              </div>
              
              {/* Status Dot */}
              <Tooltip title={statusTooltip}>
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: dotColor,
                    border: "2px solid white",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                  }}
                />
              </Tooltip>
            </div>

            {/* Text info */}
            <div style={{ minWidth: 0 }}>
              <div style={{ 
                fontSize: "13px", 
                fontWeight: "bold",
                color: "#186a3b",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}>
                {record.fullname}
              </div>
              
              <div style={{ fontSize: "10px", color: "#BFBFBF" }}>
                ID: {record.idnumber}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "ភេទ",
      dataIndex: "gender",
      width: 80,
      align: "center",
      render: (text) => (
        <Tag color={text === "ប្រុស" ? "blue" : text === "ស្រី" ? "pink" : "default"}>
          {text === "ប្រុស" ? "♂ ប្រុស" : text === "ស្រី" ? "♀ ស្រី" : text}
        </Tag>
      ),
    },
    {
      title: "ថ្ងៃខែឆ្នាំកំណើត",
      dataIndex: "dob",
      width: 120,
      render: (text) => (
        <div>{text ? formateDateSystem(text) : "-"}</div>
      ),
    },
    {
      title: "ផ្នែក និងតួរនាទី",
      dataIndex: "department",
      width: 200,
      render: (text, record) => (
        <div>
          <div style={{ fontSize: "13px", fontWeight: "bold", color: "#186a3b" }}>
            {record.department}
          </div>
          <div style={{ fontSize: "11px", color: "#888" }}>
            {record.position}
          </div>
        </div>
      ),
    },
    {
      title: "ជំនាញ",
      dataIndex: "skill",
      width: 120,
    },
    {
      title: "លេខទូរស័ព្ទ",
      dataIndex: "phone_number",
      width: 120,
    },
    {
      title: "ថ្ងៃចូលបម្រើការងារ",
      dataIndex: "joinwork",
      width: 130,
      render: (text, record) => <div>{formateDateSystem(record.joinwork)}</div>,
    },
    {
      title: "កាំប្រាក់",
      dataIndex: "level",
      width: 90,
      align: "center",
    },
    {
      title: "ថ្ងៃឡើងកាំប្រាក់",
      dataIndex: "date_last_upgrad",
      width: 130,
      render: (text, record) => (
        <div>{record.date_last_upgrad ? formateDateSystem(record.date_last_upgrad) : "-"}</div>
      ),
    },
    {
      title: "ប្រភេទបុគ្គលិក",
      dataIndex: "stafftype",
      width: 130,
      render: (text, record) => (
        <>{getJobStatus(record.stafftype)}</>
      ),
    },
    {
      title: "ស្ថានភាពការងារ",
      dataIndex: "jobstatus",
      width: 120,
      render: (text, record) => (
        <>{getJobStatus(record.jobstatus)}</>
         
      ),
    },
    {
      title: "ស្ថានភាពគណនី",
      dataIndex: "lock_user",
      width: 100,
      align: "center",
      render: (text, record) => (
        <Tag color={record.lock_user === 1 ? "success" : "error"}>
          {record.lock_user === 1 ? "សកម្ម" : "អសកម្ម"}
        </Tag>
      ),
    },
    {
      title: "សកម្មភាព",
      width: 100,
      align: "center",
      fixed: "right",
      render: (_, record, index) => (
        <Space>
          <Tooltip title="កែប្រែ">
            <Button type="primary" icon={<MdOutlineEdit />} size="small" />
          </Tooltip>
          <Tooltip title="លុប">
            <Button type="primary" icon={<MdOutlineDelete />} danger size="small" />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // Export to Excel - Main Staff Gov
  const onExporttoExcel = async () => {
    const orgCodes = param_org;
    const idorg = Array.isArray(orgCodes) ? orgCodes.join(",") : orgCodes;

    console.log("ID org : ", idorg);

    const param = new URLSearchParams({
      idorg: idorg,
    });

    try {
      const res = await request(`employeeexcel?${param.toString()}`, "get", {});
      if (res) {
        const dataArray = Array.isArray(res.ListEmployeeDownloadExcell_gov)
          ? res.ListEmployeeDownloadExcell_gov[0] || []
          : [];

        setListExcelData(dataArray);
        console.log("res", dataArray);

        return dataArray;
      }
    } catch (error) {
      console.error("Error fetching Excel data:", error);
    }

    return [];
  };

  // Export to Excel - Other Staff
  const onExporttoExcel_other = async () => {
    const orgCodes = param_org;
    const idorg = Array.isArray(orgCodes) ? orgCodes.join(",") : orgCodes;

    console.log("ID org : ", idorg);

    const param = new URLSearchParams({
      idorg: idorg,
    });
    
    try {
      const res = await request(`employeeexcel?${param.toString()}`, "get", {});
      if (res) {
        const dataArray = Array.isArray(res.ListEmployeeDownloadExcell_other[0])
          ? res.ListEmployeeDownloadExcell_other[0]
          : [];
        setListExcelData(dataArray);
        console.log("res", dataArray);

        return dataArray;
      }
    } catch (error) {
      console.error("Error fetching Excel data:", error);
    }

    return [];
  };

  // Export to Excel - Total All
  const onExporttoExcel_TotalAll = async () => {
    const orgCodes = param_org;
    const idorg = Array.isArray(orgCodes) ? orgCodes.join(",") : orgCodes;

    console.log("ID org : ", idorg);

    const param = new URLSearchParams({
      idorg: idorg,
    });
    
    try {
      const res = await request(`employeeexcel?${param.toString()}`, "get", {});
      if (res) {
        const dataArray = Array.isArray(
          res.ListEmployeeDownloadExcell_TotalAll[0]
        )
          ? res.ListEmployeeDownloadExcell_TotalAll[0]
          : [];
        setListExcelData(dataArray);
        console.log("res", dataArray);

        return dataArray;
      }
    } catch (error) {
      console.error("Error fetching Excel data:", error);
    }

    return [];
  };

  const downloadExcel = async () => {
    const OrgName = getProfile.org_name_kh;

    try {
      setLoadingSpin(true);
      setDownloadReport(false);

      // Fetch data and ensure it's an array
      const data = (await onExporttoExcel()) || [];
      const data_other = (await onExporttoExcel_other()) || [];
      const data_TotalAll = (await onExporttoExcel_TotalAll()) || [];

      // Load the template Excel file from the public folder
      const templatePath =
        process.env.PUBLIC_URL + "/template/templatestaff.xlsx";
      const response = await fetch(templatePath);
      const templateArrayBuffer = await response.arrayBuffer();

      // Create a workbook from the template file
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(templateArrayBuffer);

      // Get the sheets from the workbook
      const dataSheet = workbook.getWorksheet("staffgov");
      const otherSheet = workbook.getWorksheet("staffothers");
      const TotalAllSheet = workbook.getWorksheet("total-all");

      if (!dataSheet || !otherSheet || !TotalAllSheet) {
        console.error("One or more sheets not found in the template.");
        openNotification("error", "Error", "Template sheets not found");
        return;
      }

      dataSheet.getCell("A2").value = OrgName;

      // Convert the new data to worksheet format
      const newData = data.map((item) => Object.values(item));
      const newData_other = data_other.map((item) => Object.values(item));
      const newData_TotalAll = data_TotalAll.map((item) => Object.values(item));

      // Check if the data arrays are valid
      if (newData.length === 0) {
        console.warn("No data available for the main data sheet.");
      }
      if (newData_other.length === 0) {
        console.warn("No data available for the other data sheet.");
      }
      if (newData_TotalAll.length === 0) {
        console.warn("No data available for the total all data sheet.");
      }

      // Append the new data to the existing sheets
      if (newData.length > 0) {
        dataSheet.addTable({
          name: "dataTable",
          ref: "B6",
          headerRow: true,
          columns: Object.keys(data[0]).map((key) => ({ name: key })),
          rows: newData,
        });
      }

      if (newData_other.length > 0) {
        otherSheet.addTable({
          name: "dataTable1",
          ref: "B6",
          headerRow: true,
          columns: Object.keys(data_other[0]).map((key) => ({ name: key })),
          rows: newData_other,
        });
      }

      if (newData_TotalAll.length > 0) {
        TotalAllSheet.addTable({
          name: "dataTable2",
          ref: "A6",
          headerRow: true,
          columns: Object.keys(data_TotalAll[0]).map((key) => ({ name: key })),
          rows: newData_TotalAll,
        });
      }

      // Hide unnecessary rows in each sheet
      const hideRows = (sheet, length) => {
        const startRowToDelete = length + 7;
        const endRowToHide = 1000;

        for (let row = startRowToDelete; row <= endRowToHide; row++) {
          sheet.getRow(row).height = 0.1;
        }
      };

      hideRows(dataSheet, newData.length);
      hideRows(otherSheet, newData_other.length);
      hideRows(TotalAllSheet, newData_TotalAll.length);

      // Apply Background Color Logic
      const applyBackgroundColor = (sheet, data) => {
        for (let row = 7; row <= data.length + 6; row++) {
          const colAValue = sheet.getCell(row, 1).value;
          const colBValue = sheet.getCell(row, 2).value;
          const colCValue = sheet.getCell(row, 3).value;
          const colDValue = sheet.getCell(row, 4).value;
          
          if (
            colAValue == null &&
            colBValue == null &&
            colCValue != null &&
            colDValue == null
          ) {
            for (let col = 1; col <= 19; col++) {
              sheet.getCell(row, col).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "AED6F1" },
              };
            }
          }
        }
      };

      applyBackgroundColor(dataSheet, newData);
      applyBackgroundColor(otherSheet, newData_other);

      // Handle subtotal formulas
      const applySubtotal = (sheet, data) => {
        for (let row = 7; row <= data.length + 6; row++) {
          const cellValue = sheet.getCell(row, 2).value;
          if (cellValue === 1) {
            const subtotalFormula = {
              formula: `SUBTOTAL(109, B$7:B${row})`,
            };
            sheet.getCell(row, 1).value = subtotalFormula;
          }
        }
      };

      applySubtotal(dataSheet, newData);
      applySubtotal(otherSheet, newData_other);

      // Background color for TotalAll sheet
      for (let row = 7; row <= newData_TotalAll.length + 6; row++) {
        const cellValue = TotalAllSheet.getCell(row, 2).value;
        if (cellValue != null) {
          for (let col = 1; col <= 5; col++) {
            const cell = TotalAllSheet.getCell(row, col);
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFCCCC" },
            };
            cell.font = {
              bold: true,
              name: "Content",
            };
          }
        }
      }

      // Save the modified workbook as a Blob with XLSX format
      const blob = await workbook.xlsx.writeBuffer();
      const name_report = `StaffSummaryReport-${moment().format(
        "YYYY-MM-DD-HH-mm-ss"
      )}`;
      FileSaver.saveAs(new Blob([blob]), `${name_report}.xlsx`);
      
      openNotification("success", "Success", "Report downloaded successfully!");
    } catch (error) {
      console.error("An error occurred while generating the report:", error);
      openNotification("error", "Error", "Error while downloading report");
    } finally {
      setLoadingSpin(false);
    }
  };

  const onCancelDownload = () => {
    setDownloadReport(false);
  };

  const opOpenModelDownloadReport = () => {
    setDownloadReport(true);
  };

  const onShowSizeChange = async (current) => {
    setPageNumber(current);
    setCurrentPage(current);
    try {
      setLoadingSpin(true);
      var objTmp = {
        ...objFilter,
        page: current,
      };
      await new Promise((resolve) => setTimeout(resolve, 400));
      setObjFilter(objTmp);
      getList(objTmp);
    } catch (error) {
      console.error("Error changing page:", error);
    } finally {
      setLoadingSpin(false);
    }
  };

  const [ListMasterGroup, setListMasterGroup] = useState([]);
  const getMasterGroups = async () => {
    const param = new URLSearchParams({ org_code: getProfile.org_code });

    try {
      const res = await request("usermastergroup?" + param.toString(), "get", {});
      if (res) {
        setListMasterGroup(res.list_api_master_group[0] || []);
      }
    } catch (error) {
      console.error("Error fetching master groups:", error);
    }
  };

  const [param_org, setParamOrg] = useState(getProfile.org_code);

  const treeData = useMemo(() => {
    return ListMasterGroup.reduce((acc, item) => {
      const groupId = item.group_id || "Unknown";
      const groupName = item.group_name || item.org_name_kh || "Unknown";
      const group = acc.find((g) => g.value === groupId);
      if (group) {
        group.children.push({
          title: item.org_name_kh,
          value: item.org_code,
          key: item.organization_id,
        });
      } else {
        acc.push({
          title: groupName,
          value: groupId,
          key: `${groupId}`,
          children: [
            {
              title: item.org_name_kh,
              value: item.org_code,
              key: item.organization_id,
            },
          ],
        });
      }
      return acc;
    }, []);
  }, [ListMasterGroup]);

  const handleTreeSelectChange = (value) => {
    if (!value || value.length === 0) {
      setSelectOrgCodeSave([]);
    } else {
      setSelectOrgCodeSave(value);
    }
    setParamOrg(value);
  };

  return (
    <div>
      <div>
        <div className="sprinSave-container">
          {loadingSpin && (
            <div className="sprinSave">
              <GetLoading />
            </div>
          )}
        </div>

        <div style={boxHeader}>
          <div className="Header-Setting-Grid">
            <div className="Header-Setting-Grid-R">
              {boxHeaderTagText(`មន្រ្តីរាជការ បុគ្គលិកជួល... (សរុប: ${totalpage} នាក់)`)}

              <Space>
                <Input.Search
                  className="styleTageStatusForm"
                  placeholder="ស្វែងរកតាមឈ្មោះ ឬលេខID..."
                  allowClear
                  value={txtSearch}
                  onChange={(e) => {
                    setTxtSearch(e.target.value);
                    if (e.target.value === "") {
                      handleSearch("");
                    }
                  }}
                  onSearch={handleSearch}
                  style={{ width: 300 }}
                />
              </Space>
            </div>

            <div>
              <Space>
                <Button
                  className="buttonstylekhmer"
                  onClick={opOpenModelDownloadReport}
                  type="primary"
                  icon={<BsDownload />}
                >
                  ទាយយករបាយការណ៍
                </Button>
              </Space>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table
            size="small"
            tableLayout="auto"
            columns={columns}
            dataSource={dataSours}
            pagination={false}
            rowKey="id"
            scroll={{ x: 1600 }}
          />
        )}
        <div style={{ marginTop: 10, textAlign: "right", padding: "0 16px" }}>
          <Pagination
            showSizeChanger
            onChange={onShowSizeChange}
            defaultCurrent={currentPage}
            current={currentPage}
            total={totalpage}
            showTotal={(total) => `សរុប ${total} នាក់`}
            pageSize={pagesize}
          />
        </div>
      </div>
      
      <Modal
        title="ទាញរបាយការណ៍បុគ្គលិក"
        className="custom-modal"
        open={DownloadReport}
        onCancel={onCancelDownload}
        footer={[
          <div key="footer">
            <Space>
              <Button onClick={onCancelDownload}>បោះបង់</Button>
              <Button
                className="custom-form-item"
                type="primary"
                onClick={downloadExcel}
                loading={loadingSpin}
              >
                ទាញយកសង្ខេបរបាយការណ៍បុគ្គលិក (Excel)
              </Button>
            </Space>
          </div>,
        ]}
      >
        <div style={{ padding: "20px 0" }}>
          <p style={{ marginBottom: 10, fontWeight: "bold", color: "#186a3b" }}>
            ជ្រើសរើសអង្គភាពសម្រាប់ទាញយករបាយការណ៍:
          </p>
          <TreeSelect
            allowClear
            showSearch
            treeCheckable={true}
            multiple={true}
            style={{ width: "100%" }}
            value={selectOrgCodeSave}
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            treeData={treeData}
            placeholder="ជ្រើសរើសអង្គភាព..."
            treeDefaultExpandAll
            filterTreeNode={(input, treeNode) =>
              treeNode.title.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => handleTreeSelectChange(value)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default EmployeePage;